import React from 'react';
import './App.css';
import HeroContainer from './components/HeroContainer';
import PremiumBackground from './components/PremiumBackground';

function App() {
  return (
    <div className="App" style={{ position: 'relative', width: '100vw', minHeight: '100vh', overflowX: 'hidden' }}>
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 0, pointerEvents: 'none' }}>
        <PremiumBackground />
      </div>
      <div style={{ position: 'relative', zIndex: 1 }}>
        <HeroContainer />
      </div>
    </div>
  );
}

export default App;
